import { render, staticRenderFns } from "./assign-product-catalogs.vue?vue&type=template&id=bfe133c8&scoped=true&"
import script from "./assign-product-catalogs.vue?vue&type=script&lang=js&"
export * from "./assign-product-catalogs.vue?vue&type=script&lang=js&"
import style0 from "./assign-product-catalogs.vue?vue&type=style&index=0&id=bfe133c8&prod&lang=scss&scoped=true&"
import style1 from "./assign-product-catalogs.vue?vue&type=style&index=1&id=bfe133c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe133c8",
  null
  
)

export default component.exports